const trackingUtils = require('od-modules/utils/tracking.utils');
const myTripsUtils = require('od-modules/utils/my_trips.utils');

const CATEGORY = 'my_area_trips_details';
const ON_LOAD_ACTION = 'checkin_onload';

module.exports = {
    CATEGORY,
    ON_LOAD_ACTION,
    trackAutoCheckinOk(bookingData) {
        trackCheckinLoad(bookingData, 'checkinMfOnLoadOKSuccess');
    },
    trackAutoCheckinFailed(bookingData) {
        trackCheckinLoad(bookingData, 'checkinMfOnLoadOKFailed');
    },
    trackAutoCheckinPending(bookingData) {
        trackCheckinLoad(bookingData, 'checkinMfOnLoadOKCreate');
    },
    trackCheckinNotAvailable(bookingData) {
        trackCheckinLoad(bookingData, 'checkinMfOnLoadCsna');
    },
    trackBookingStatusNotAllowed(bookingData) {
        trackCheckinLoad(bookingData, 'checkinMfOnLoadNoConf');
    },
    trackNotInScope(bookingData) {
        trackCheckinLoad(bookingData, 'checkinMfOnLoadScope');
    },
    trackNoSeatsAvailableReason(bookingData) {
        trackCheckinLoad(bookingData, 'checkinMfOnLoadSeatNa');
    },
    trackExtraInfoNeeded(bookingData) {
        trackCheckinLoad(bookingData, 'checkinMfOnLoadOKMoreInfo');
    },
    trackCimf(bookingData) {
        trackCheckinLoad(bookingData, 'checkinMfOnLoadOK');
    },
    trackCheckinErrorShowMore(action) {
        const label = `show-${action}_checkin-request-failed_pag:tripdetails`;
        trackingUtils.trackEventWithCategory('tripdetails', 'checkin_click', label);
    },
    trackCheckinStatusPaid(isCheckinPaid) {
        const label = `onload_checkin_pag:tripdetails_status:${isCheckinPaid}`;
        trackingUtils.trackEventWithCategory('tripdetails', ON_LOAD_ACTION, label);
    },
    trackOnloadCheckinMoreInfoNag() {
        trackingUtils.trackEventWithCategory('tripdetails', 'checkin_onload_nag', 'nag-onload_checkin_pag:tripdetails');
    },
    trackClickCheckinMoreInfoNag(nagAction) {
        const label = `nag-${nagAction}_checkin_pag:tripdetails`;
        trackingUtils.trackEventWithCategory('tripdetails', 'checkin_click_nag', label);
    },
    trackPage: function(page, childPage = null) {
        const subPage = childPage ? `/${childPage}` : '';
        trackingUtils.trackPage(`PB/check-in/${page}${subPage}`, {
            funnel: false,
        });
    },
};

function trackCheckinLoad(bookingData, label) {
    trackingUtils.trackEventWithCategory(CATEGORY, ON_LOAD_ACTION, myTripsUtils.checkinMfTracking(bookingData, label));
}
